import React from "reactn";
import { StepIndicator } from "../../../components/UI";
import Setup from "./Setup";
import Final from "./Final";
import StepBar from "../../../components/UI/StepBar";
import Validators from "../../../validators";
import { canUserCreate } from "../../../utilities/listingCreation";

import axios from "axios";
import ListingSaveButton from "../../../components/UI/ListingSaveButton";
class NewsUpdatesSteps extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      canUserMakeNew: false,
      makeReqMessage: "",
      isInitialized: false,
      step: 0
    };
    this.titles = ["Set-up", "Additional Section"];
    this.validate = [
      () =>
        Validators.Partners.Profile.ValidateNews(this.global.news_and_updates)
    ];
    this.steps = [
      { name: "Set-up", validateFn: this.validate[0] },
      { name: "Additional Section", validateFn: _ => true }
    ];
  }

  async componentDidMount() {
    const canUserMake = await canUserCreate("update");
    this.setState({
      canUserMakeNew: canUserMake.success,
      makeReqMessage: canUserMake.message
    });

    if (this.props.match.params.id) {
      await this.dispatch.getNews(this.props.match.params.id);
    } else {
      await this.dispatch.resetEvent();
    }

    this.setState({ isInitialized: true });

    this.setGlobal({
      partnerPathway: [
        ...this.global.partnerPathway.slice(0, 1),
        { label: "News & Updates", to: "/news-updates" },
        {
          label: this.global.news_and_updates.title || "News & Updates Setup",
          to: this.props.location.pathname.replace(/^\/partners/, "") // remove /partners from pathname
        }
      ]
    });
  }

  saveProfile = async e => {
    const { step } = this.state;
    switch (e.target.name) {
      case "next":
        this.setState({ step: step + 1 });
        await this.dispatch.saveNews();
        break;
      case "back":
        this.setState({ step: step - 1 });
        await this.dispatch.saveNews();
        break;
      case "save":
        await this.dispatch.saveNews();
        break;
      default:
        return;
    }
  };

  changePage = async page => {
    if (!this.checkValid()) {
      await this.dispatch.saveNews();
      this.setState({ step: page });
    }
  };

  getPage = () => {
    switch (this.state.step) {
      case 0:
        return <Setup />;
      case 1:
        return <Final />;
      default:
        return <Setup />;
    }
  };

  checkValid() {
    const { step } = this.state;
    return this.validate[step] && !this.validate[step]();
  }

  getCompletion() {
    let completed = 0;
    for (let v of this.validate) {
      completed += v();
    }
    return (completed / this.validate.length) * 100;
  }

  render() {
    if (!this.state.canUserMakeNew && !this.props.match.params.id) {
      return (
        <div className="container-fluid">
          {/* Commented out to make space for Top Bar */}
          {/* <div className="cont">
            <h1 className="events-title-header">Memberships</h1>
          </div> */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              height: "50vh",
              alignItems: "center"
            }}
          >
            <p>{this.state.makeReqMessage}</p>
          </div>
        </div>
      );
    }

    return (
      <div className="container-fluid">
        {/* Commented out to make space for Top Bar */}
        {/* <div className="cont">
          <h1 className="events-title-header">
            Create News & Updates
          </h1>
        </div> */}
        <StepBar
          {...{
            steps: this.steps,
            changeFn: this.changePage,
            current: this.state.step
          }}
        />
        <StepIndicator value={this.getCompletion()} />
        {this.getPage()}
        <div className="cont mb-5">
          <div
            className="buttons w-100"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end"
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "80%"
              }}
            >
              <div
                name="back"
                disabled={this.state.step === 0}
                onClick={e => {
                  e.target.name = "back";
                  if (this.state.step === 0) return;
                  this.saveProfile(e);
                }}
              >
                <i
                  name="back"
                  style={{ paddingRight: "24px" }}
                  className={`fas fa-chevron-left ${
                    this.state.step === 0
                      ? "listing-step-btn-inactive"
                      : "listing-step-btn-active"
                  }`}
                ></i>
              </div>
              <div
                name="next"
                onClick={e => {
                  e.target.name = "next";
                  if (
                    this.state.step === this.titles.length - 1 ||
                    this.checkValid()
                  )
                    return;
                  this.saveProfile(e);
                }}
              >
                <i
                  name="next"
                  style={{ paddingLeft: "24px" }}
                  className={`fas fa-chevron-right ${
                    this.state.step === this.titles.length - 1 ||
                    this.checkValid()
                      ? "listing-step-btn-inactive"
                      : "listing-step-btn-active"
                  }`}
                ></i>
              </div>
            </div>
            {/* <button
              onClick={this.saveProfile}
              disabled={this.state.step === 0}
              name="back"
              className="nextbtn"
            >
              BACK
            </button> */}
            <div style={{ width: "10%" }}>
              <ListingSaveButton
                listing={this.global.news_and_updates}
                saveResult={this.global.lastAPICall}
                trackingEnabled={this.state.isInitialized}
                onClick={this.saveProfile}
                name="save"
                className="savebtn"
              >
                SAVE
              </ListingSaveButton>
            </div>
            {/* <button
              onClick={this.saveProfile}
              disabled={
                this.state.step === this.titles.length - 1 || this.checkValid()
              }
              name="next"
              className="nextbtn"
            >
              NEXT
            </button> */}
          </div>
        </div>
      </div>
    );
  }
}

export default NewsUpdatesSteps;
